export const INPUT_FIELDS_DEBOUNCE_TIMEOUT = 700;
